<template>
  <v-tooltip right>
    <template #activator="{ on }">
      <v-icon :color="icon.color" medium v-on="on">{{ icon.icon }}</v-icon>
    </template>
    <span>{{ icon.tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'RuleIcon',
  props: {
    rule: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    icons: {
      block: {
        color: 'warning',
        icon: 'block',
        tooltip: 'Limit traffic rule',
      },
      fullBlock: {
        color: 'error',
        icon: 'block',
        tooltip: 'Block traffic rule',
      },
      receive: {
        color: 'success',
        icon: 'check_circle_outline',
        tooltip: 'Receive traffic rule',
      },
    },
  }),
  computed: {
    icon() {
      return this.icons[this.rule]
    },
  },
}
</script>
